import { Icon } from '@/components/ui/Icon'
import { groupMeta, type ListGroup } from '@/lib/categories'
import { cx } from '@/lib/ui'

/**
 * Sticky heading above each group in the library and the palette — a
 * category, or the pinned Favourites / Recently placed groups. Deliberately a
 * <p>, never a button or heading: the device rows are addressed by role, and a
 * header must never be a candidate.
 */
export function DeviceGroupHeader({
  group,
  count,
  surface,
}: {
  group: ListGroup
  count: number
  /** Solid white list (library) or frosted panel (palette). */
  surface: 'card' | 'glass'
}) {
  const meta = groupMeta(group)
  return (
    <p
      className={cx(
        'sticky top-0 z-10 -mx-2 flex items-center gap-1.5 px-4 py-1.5 text-[10px] font-medium uppercase tracking-[0.08em] text-muted backdrop-blur',
        surface === 'card' ? 'bg-surface/90' : 'bg-[var(--surface-glass)]',
      )}
    >
      <Icon name={meta.icon} strokeWidth={2} className="h-3 w-3" />
      <span>{surface === 'glass' ? meta.short : meta.label}</span>
      <span className="font-mono text-muted/70">{count}</span>
    </p>
  )
}
